import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { GlobalErrorService } from './global-error.service';

/** catches http exceptions and routes them to the {@link GlobalErrorService} */
@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(private errorService: GlobalErrorService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        this.errorService.handleHttpError(request, error);
        return throwError(error);
      })
    ) as Observable<HttpEvent<any>>;
  }
}
